import { computed } from 'vue'

import { PreferenceType } from '@/contexts/preferences/Preferences.interfaces'
import { usePreference } from '@/contexts/preferences/Preferences.composables'
import { PREFERENCE_KEYS } from '@/contexts/preferences/Preferences.constants'

export const useActionReviewPreference = () => {
  const { preference, fetchPreference } = usePreference(PREFERENCE_KEYS.ACTION_REVIEW, PreferenceType.BOOLEAN)

  const hasActionReviewPreference = computed(() => preference.value ?? false)

  const fetchActionReviewPreference = async () => {
    await fetchPreference()
  }

  return {
    hasActionReviewPreference,
    fetchActionReviewPreference,
  }
}
